import React from 'react';
import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';
const images = [{
  src: 'https://cdn.magicpatterns.com/uploads/rMP1HzxZ7VN1vFmy6GXjDj/arestaurante_cabrera.jpg',
  label: 'El Ambiente',
  tag: 'Experiencia',
  layout: 'md:row-span-2',
  height: 'h-[400px] md:h-full'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5Xyz55VizUErUiCbdUZjzw/carne_parrilla.jpg',
  label: 'Nuestros Cortes',
  tag: 'Premium',
  layout: 'md:col-span-2',
  height: 'h-[280px]'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5MNExqAfM4W39C5ccx47WL/restaurante_bar_6.jpg',
  label: 'Hamburguesas',
  tag: 'Menú',
  layout: '',
  height: 'h-[280px]'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/nR9GuhnKMZU18CAyUTp8BC/ewDFdfadsf.jpg',
  label: 'Mixología',
  tag: 'Cócteles',
  layout: '',
  height: 'h-[280px]'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/biFRo2gJ5vHADAf7dQ5Bwk/resaturante_cabrerabar_2.jpg',
  label: 'La Experiencia',
  tag: 'Momentos',
  layout: 'md:col-span-2',
  height: 'h-[280px]'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/shF5JfuwYVPApAQg3UYr4A/restaurante_cabrera_4.jpg',
  label: 'Para Compartir',
  tag: 'Gastronomía',
  layout: '',
  height: 'h-[280px]'
}];
export function Gallery() {
  return <section className="py-20 md:py-32 bg-brand-secondary overflow-hidden" data-id="element-165">
      <style data-id="element-166">{`
        .gallery-item {
          position: relative;
          overflow: hidden;
          border-radius: 16px;
          cursor: pointer;
        }

        .gallery-item img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94);
          animation: kenBurns 18s ease-in-out infinite alternate;
          will-change: transform;
        }

        .gallery-item:nth-child(2) img { animation-delay: -3s; }
        .gallery-item:nth-child(3) img { animation-delay: -6s; }
        .gallery-item:nth-child(4) img { animation-delay: -9s; }
        .gallery-item:nth-child(5) img { animation-delay: -12s; }
        .gallery-item:nth-child(6) img { animation-delay: -15s; }

        @keyframes kenBurns {
          0%   { transform: scale(1)    translate(0, 0); }
          50%  { transform: scale(1.06) translate(-1.5%, 1%); }
          100% { transform: scale(1.04) translate(1.5%, -1%); }
        }

        .gallery-item:hover img {
          transform: scale(1.12);
          animation-play-state: paused;
        }

        .gallery-shine {
          position: absolute;
          top: 0;
          left: -75%;
          width: 50%;
          height: 100%;
          background: linear-gradient(
            120deg,
            transparent 0%,
            rgba(255, 255, 255, 0.08) 50%,
            transparent 100%
          );
          transform: skewX(-20deg);
          pointer-events: none;
          opacity: 0;
          transition: opacity 0.2s ease;
        }

        .gallery-item:hover .gallery-shine {
          opacity: 1;
          animation: shine 1.2s ease-out;
        }

        @keyframes shine {
          0%   { left: -75%; }
          100% { left: 125%; }
        }

        .gallery-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            to top,
            rgba(0,0,0,0.85) 0%,
            rgba(0,0,0,0.2) 40%,
            transparent 100%
          );
          opacity: 0;
          transition: opacity 0.4s ease;
        }

        .gallery-item:hover .gallery-overlay {
          opacity: 1;
        }

        .gallery-tag {
          position: absolute;
          top: 16px;
          right: 16px;
          background: #C9A84C;
          color: #1A0A00;
          font-size: 11px;
          font-weight: 700;
          padding: 4px 12px;
          border-radius: 999px;
          letter-spacing: 1px;
          text-transform: uppercase;
          opacity: 0;
          transform: translateY(-10px);
          transition: opacity 0.3s ease, transform 0.3s ease;
        }

        .gallery-item:hover .gallery-tag {
          opacity: 1;
          transform: translateY(0);
        }

        .gallery-label {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          padding: 20px;
          opacity: 0;
          transform: translateY(16px);
          transition: opacity 0.4s ease, transform 0.4s ease;
        }

        .gallery-item:hover .gallery-label {
          opacity: 1;
          transform: translateY(0);
        }

        .gallery-label-sub {
          color: #C9A84C;
          font-size: 11px;
          letter-spacing: 3px;
          text-transform: uppercase;
          margin-bottom: 4px;
          font-weight: 500;
        }

        .gallery-label-title {
          color: white;
          font-size: 22px;
          font-family: serif;
          margin-bottom: 8px;
        }

        .gallery-line {
          height: 2px;
          background: #C9A84C;
          border-radius: 999px;
          width: 0;
          transition: width 0.5s ease 0.1s;
        }

        .gallery-item:hover .gallery-line {
          width: 56px;
        }

        .gallery-border {
          position: absolute;
          inset: 0;
          border-radius: 16px;
          border: 2px solid #C9A84C;
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.3s ease;
        }

        .gallery-item:hover .gallery-border {
          opacity: 1;
        }

        .gallery-corner {
          position: absolute;
          top: 0;
          left: 0;
          width: 80px;
          height: 80px;
          border-radius: 16px 0 0 0;
          background: linear-gradient(
            135deg,
            rgba(201,168,76,0.3) 0%,
            transparent 60%
          );
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.3s ease;
        }

        .gallery-item:hover .gallery-corner {
          opacity: 1;
        }

        .gallery-title-line {
          height: 4px;
          background: #C9A84C;
          border-radius: 999px;
          margin: 0 auto;
          animation: expandLine 0.8s ease 0.3s forwards;
          width: 0;
        }

        @keyframes expandLine {
          from { width: 0; }
          to { width: 96px; }
        }

        .ig-btn {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 14px 32px;
          border-radius: 999px;
          border: 2px solid rgba(201,168,76,0.5);
          color: #F5F0E8;
          font-size: 13px;
          font-weight: 500;
          letter-spacing: 1px;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .ig-btn:hover {
          background: #C9A84C;
          color: #1A0A00;
          border-color: #C9A84C;
          transform: scale(1.05);
        }

        .ig-btn svg {
          color: #C9A84C;
          transition: color 0.3s ease;
        }

        .ig-btn:hover svg {
          color: #1A0A00;
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167">
        {/* Title */}
        <div className="text-center mb-16" data-id="element-168">
          <p style={{
          color: '#C9A84C',
          fontSize: '12px',
          letterSpacing: '4px',
          textTransform: 'uppercase',
          marginBottom: '16px',
          fontWeight: 500
        }} data-id="element-169">
            Nuestro Espacio
          </p>
          <h2 className="text-3xl md:text-5xl font-serif text-brand-cream mb-6" data-id="element-170">
            La Experiencia en Imágenes
          </h2>
          <div className="gallery-title-line" data-id="element-171" />
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-12" data-id="element-172">
          {images.map((image, index) => <motion.div key={index} className={`gallery-item ${image.layout} ${image.height}`} initial={{
          opacity: 0,
          y: 40,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          y: 0,
          scale: 1
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.7,
          delay: index * 0.12,
          ease: [0.25, 0.46, 0.45, 0.94]
        }} whileHover={{
          y: -6
        }} data-id="element-173">
              <img src={image.src} alt={image.label} data-id="element-174" />
              <div className="gallery-shine" data-id="element-175" />
              <div className="gallery-overlay" data-id="element-176" />
              <div className="gallery-tag" data-id="element-177">{image.tag}</div>
              <div className="gallery-label" data-id="element-178">
                <p className="gallery-label-sub" data-id="element-179">Cabrera Resto-Bar</p>
                <h3 className="gallery-label-title" data-id="element-180">{image.label}</h3>
                <div className="gallery-line" data-id="element-181" />
              </div>
              <div className="gallery-border" data-id="element-182" />
              <div className="gallery-corner" data-id="element-183" />
            </motion.div>)}
        </div>

        {/* Instagram Button */}
        <div className="text-center mt-8" data-id="element-184">
          <a href="https://instagram.com/cabrera.restobar" target="_blank" rel="noreferrer" className="ig-btn" data-id="element-185">
            <Instagram size={20} data-id="element-186" />
            VER MÁS EN INSTAGRAM @cabrera.restobar
          </a>
        </div>
      </div>
    </section>;
}